// บช ที่ใช้งานได้ในระบบ
import iconTrue from "../assets/images/icon/true.png";

export const ActiveBankDataSelector = [
    {
        bankCode: "004",
        bankNameTH: "ธนาคารกสิกรไทย",
        bank_id: "kbank",
        bankNameEN: "Kasikorn Bank",
        accountLength: 10,
        status: true,
        bankLogo: "https://assets.slipmate.ai/public/banks-logo/KBANK.png",
    },
    {
        bankCode: "014",
        bankNameTH: "ธนาคารไทยพาณิชย์",
        status: true,
        bank_id: "scb",
        bankNameEN: "Siam Commercial Bank",
        accountLength: 10,
        bankLogo: "https://assets.slipmate.ai/public/banks-logo/SCB.png",
    },
    {
        bankCode: "006",
        bankNameTH: "ธนาคารกรุงไทย",
        status: true,
        bank_id: "ktb",
        bankNameEN: "Krungthai Bank",
        accountLength: 10,
        bankLogo: "https://assets.slipmate.ai/public/banks-logo/KTB.png",
    },
    {
        bankCode: "025",
        bankNameTH: "ธนาคารกรุงศรีอยุธยา",
        status: true, 
        bank_id: "bay",
        bankNameEN: "Bank of Ayudhya (Krungsri)",
        accountLength: 10,
        bankLogo: "https://assets.slipmate.ai/public/banks-logo/BAY.png",
    },
    {
        bankCode: "030",
        bankNameTH: "ธนาคารออมสิน",
        status: true, 
        bank_id: "gsb",
        bankNameEN: "Government Savings Bank",
        bankLogo: "https://assets.slipmate.ai/public/banks-logo/GSB.png",
        accountLength: 12, // หรือ 12, ขึ้นอยู่กับประเภทบัญชี
    },
    {
        bankCode: "011",
        bankNameTH: "ธนาคารทหารไทยธนชาต",
        status: true,
        bank_id: "ttb",
        bankNameEN: "TMBThanachart Bank",
        bankLogo: "https://assets.slipmate.ai/public/banks-logo/TTB.png",
        accountLength: 10,
    },
    {
        bankCode: "073",
        bankNameTH: "ธนาคารแลนด์ แอนด์ เฮ้าส์",
        status: false, // ปิดการใช้งาน LHB ชั่วคราว
        bank_id: "lhb",
        bankNameEN: "Land and Houses Bank",
        bankLogo: "https://assets.slipmate.ai/public/banks-logo/LHB.png",
        accountLength: 10,
    },
    {
        bankCode: "070",
        bankNameTH: "ธนาคารไอซีบีซี (ไทย)",
        status: true,
        bank_id: "icbc",
        bankNameEN: "Industrial and Commercial Bank of China (Thai)",
        bankLogo: "https://assets.slipmate.ai/public/banks-logo/ICBC.png",
        accountLength: 10,
    },
    {
        bankCode: "TRUE",
        bankNameTH: "ทรูวอลเลท",
        status: true,
        bank_id: "true",
        bankNameEN: "True Wallet",
        bankLogo: iconTrue,
        accountLength: 10,
    },
];


export const itemFormConfig = [
    { // GSB BUSINESS
        formChannel: "gsb-business",
        formItem: 6,
        title: null,
        action: null,
        note: null,
        fields: [
            { name: "companyId", defaultValue: "", label: "Company ID", type: "text", show: true, tooltip: null, require: true, span: 12 },
            { name: "username", defaultValue: "", label: "Username (Maker)", type: "text", show: true, tooltip: "กรอกข้อมูล Username ผู้ทำรายการ (Maker)", require: true, span: 12 },
            { name: "password", defaultValue: "", label: "Password (Maker)", type: "password", show: true, tooltip: "กรอกข้อมูล Password ผู้ทำรายการ (Maker)", require: true, span: 12 },
            { name: "personalId", defaultValue: "", label: "Personal ID (Authorizer)", tooltip: "กรอกข้อมูล PersonalId ผู้อนุมัติ (Authorizer)", type: "text", show: true, require: true, span: 24 },
            { name: "authn_username", defaultValue: "", label: "Username (Authorizer)", tooltip: "กรอกข้อมูล Username ผู้อนุมัติ (Authorizer)", type: "text", show: true, require: true, span: 12 },
            { name: "authn_password", defaultValue: "", label: "Password (Authorizer)", tooltip: "กรอกข้อมูล Password ผู้อนุมัติ (Authorizer)", type: "password", show: true, require: true, span: 12 },
        ]
    },
    { // Krungsri Biz Online
        formChannel: "krungsribizonline",
        formItem: 2,
        title: null,
        action: 'Click',
        note: "alert_pushbullet_guide",
        fields: [
            { name: "deviceId", defaultValue: "", label: "Username", type: "text", show: true, require: true, tooltip: null, span: 12 },
            { name: "pin", defaultValue: "", label: "Password", type: "password", show: true, require: true, tooltip: null, span: 12 },
            { name: "pushToken", defaultValue: "", label: "PushToken", type: "text", show: true, require: true, tooltip: 'tooltip_pushbullet_guide', span: 12 },

        ]
    },
    { // TTB BUSINESS
        formChannel: "ttb-business",
        formItem: 2,
        title: null,
        note: null,
        action: null,
        fields: [
            { name: "username", defaultValue: "", label: "Username", type: "text", show: true, require: true, tooltip: null, span: 12 },
            { name: "password", defaultValue: "", label: "Password", type: "password", show: true, require: true, tooltip: null, span: 24 }
        ]
    },
    { // ICBC-BIZ
        formChannel: "icbc-biz",
        formItem: 2,
        title: null,
        action: null,
        note: null,
        fields: [
            { name: "username", defaultValue: "", readOnly: false, label: "Username", type: "text", show: true, require: true, tooltip: null, span: 12 },
            { name: "password", defaultValue: "", readOnly: false, label: "Password", type: "password", show: true, require: true, tooltip: 'login อาจใช้เวลา 30-50 วินาที', span: 24 }
        ]
    },
    {// LHB-BIZ
        formChannel: "lhb-biz",
        formItem: 2,
        title: null,
        note: null,
        action: null,
        fields: [
            { name: "username", label: "Username", type: "text", show: true, require: true, tooltip: null, span: 12 },
            { name: "password", label: "Password", type: "password", show: true, require: true, tooltip: null, span: 24 }
        ]
    },
    { // TrueMoney Wallet
        formChannel: "true-wallet",
        formItem: 1,
        title: "คู่มือการใช้งาน TrueMoney Wallet",
        action: 'Click',
        note: "note_truewallet_guide",
        fields: [
            { name: "pin", label: "Secret key", defaultValue: "", readOnly: false, type: "pin", show: true, require: true, tooltip: 'tooltip_truewallet_guide', span: 12 },
            { name: "deviceId", label: "Balance Authorization", readOnly: false, defaultValue: "", type: "text", show: true, require: true, tooltip: null, span: 12 },
            // { name: "accountRefId", label: "Webhook", readOnly: true,  defaultValue: "", type: "text", show: true, require: false, tooltip: 'tooltip_truewallet_guide', span: 24 },

        ]
    },
    { // KBANK-BUSINESS
        formChannel: "kbank-business",
        formItem: 2,
        title: null,
        action: null,
        note: null,
        fields: [
            { name: "deviceId", label: "Username", defaultValue: "", type: "text", show: true, require: true, tooltip: null, span: 12 },
            { name: "pin", label: "Password", defaultValue: "", type: "password", show: true, require: true, tooltip: null, span: 24 }
        ]
    },
    { // K-BIZ
        formChannel: "k-biz",
        formItem: 2,
        title: null,
        action: null,
        note: null,
        fields: [
            { name: "deviceId", label: "Username", defaultValue: "", type: "text", show: true, require: true, tooltip: null, span: 12 },
            { name: "pin", label: "Password", defaultValue: "", type: "password", show: true, require: true, tooltip: null, span: 24 }
        ]
    },
    { // K-BIZ-QR
        formChannel: "k-biz-qr",
        formItem: 2,
        title: null,
        action: null,
        note: null,
        fields: [
            { name: "deviceId", label: "Username", defaultValue: "", type: "text", show: true, require: true, tooltip: null, span: 12 },
            { name: "pin", label: "Password", defaultValue: "", type: "password", show: true, require: true, tooltip: null, span: 24 }
        ]
    },
    { // SCB BUSINESS
        formChannel: "scb-business",
        formItem: 2,
        title: null,
        action: null,
        note: null,
        fields: [
            { name: "deviceId", label: "User ID", defaultValue: "", type: "text", show: true, require: true, tooltip: null, span: 12 },
            { name: "pin", label: "Password", defaultValue: "", type: "password", show: true, require: true, tooltip: null, span: 24 },
            // { name: "accountRefId", label: "SCB KEY", type: "password", require: true, tooltip: null, span: 12 },
            // { name: "visitorId", label: "Visitor ID", type: "password", tooltip: null, require: true, span: 12 },
            // { name: "visitorKey", label: "Visitor Key", type: "password", require: true, tooltip: null, span: 24 }
        ]
    },
    { // SCB EASY
        formChannel: "scb-easy",
        formItem: 2,
        title: null,
        action: null,
        note: null,
        fields: [
            { name: "deviceId", label: "User ID", defaultValue: "", type: "text", show: true, tooltip: null, require: true, span: 12 },
            { name: "pin", label: "Password", defaultValue: "", type: "password", show: true, tooltip: null, require: true, span: 24 }
        ]
    },
    { // KTB BUSINESS
        formChannel: "ktb-business",
        formItem: 5,
        title: null,
        action: null,
        note: null,
        fields: [
            { name: "deviceId", label: "Device ID (Optional)", defaultValue: "", type: "text", show: true, tooltip: null, require: false, span: 12 },
            { name: "pin", label: "PIN", defaultValue: "", type: "password", show: true, tooltip: null, require: true, span: 24 },
            { name: "username", label: "Username", defaultValue: "", type: "text", show: true, tooltip: null, require: true, span: 12 },
            { name: "password", label: "Password", defaultValue: "", type: "password", show: true, tooltip: null, require: true, span: 12 },
            { name: "companyId", label: "Company ID", defaultValue: "", type: "text", show: true, tooltip: null, require: true, span: 24 },
        ]
    },
];


export const ChannelsBank = {
    scb: [
        { value: "scb-easy", label: "SCB EASY" },
        { value: "scb-business", label: "SCB Business" }
    ],
    kbank: [
        { value: "k-biz", label: "K-BIZ" },
        { value: "k-biz-qr", label: "K-BIZ-QR" },
        { value: "kbank-business", label: "KBANK BUSINESS" }
    ],
    ktb: [
        { value: "KTB_NEX", label: "KTB NEX" },
        { value: "ktb-business", label: "KTB BUSINESS" }
    ],
    bay: [
        { value: "krungsribizonline", label: "Krungsribiz Online" }
    ],
    gsb: [
        { value: "gsb-business", label: "GSB BUSINESS" }
    ],
    ttb: [
        { value: "ttb-business", label: "TTB BUSINESS" }
    ],
    lhb: [
        { value: "lhb-biz", label: "LHB-BIZ" }
    ],
    icbc: [
        { value: "icbc-biz", label: "ICBC-BIZ" }
    ],
    true: [
        { value: "true-wallet", label: "TRUE WALLET" }
    ],
};


export const ValidChannels = {
    kbank: ["k-biz", "kbank-business", "k-biz-qr"],
    scb: ["scb-easy", "scb-business"],
    ktb: ["KTB_NEX", "ktb-business"],
    bay: ["krungsribizonline"],
    gsb: ["gsb-business"],
    ttb: ["ttb-business"],
    lhb: ["lhb-biz"],
    icbc: ["icbc-biz"],
    true: ["true-wallet"],

};

export const TypeOptions = (t, checkBank) => [
    {
        value: "withdrawal",
        label: t("Withdrawal"),
        disabled: ["lhb", "ttb", "true", "icbc"].includes(checkBank), // ปิดการใช้งานสำหรับ lhb, ttb, true, icbc
        title: ["lhb", "ttb", "true", "icbc"].includes(checkBank) ? t("Not support") : t("Withdrawal")
    },
    {
        value: "deposit",
        label: t("Deposit"),
        disabled: ["gsb"].includes(checkBank),
        title: ["gsb"].includes(checkBank) ? t("Not support") : t("Deposit")
    },
    {
        value: "verifying_account",
        label: t("verifying_account"),
        disabled: !["ktb", "scb"].includes(checkBank),
        title: !["ktb", "scb"].includes(checkBank) ? t("Not support") : t("verifying_account")
    },
];